import { render, staticRenderFns } from "./addCourseDialog.vue?vue&type=template&id=6ec7106e&scoped=true&"
import script from "./addCourseDialog.vue?vue&type=script&lang=js&"
export * from "./addCourseDialog.vue?vue&type=script&lang=js&"
import style0 from "./addCourseDialog.vue?vue&type=style&index=0&id=6ec7106e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec7106e",
  null
  
)

export default component.exports